import * as React from "react";
const SvgChevronLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.867}
      d="m10.914 16 9.9-9.9M10.914 16l9.9 9.9"
    />
  </svg>
);
export default SvgChevronLeft;
